import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Col, ControlLabel, FormGroup } from 'react-bootstrap';
import DatePickerSimple from './DatePickerSimple';
import moment from 'moment';
import 'moment/locale/en-gb';
import './styles.scss';

class DatePickerDob extends Component {
  state = {
    inputDate: undefined,
    minDate: undefined,
    maxDate: undefined,
  };
  static propTypes = {
    label: PropTypes.string,
    input: PropTypes.object.isRequired,
    meta: PropTypes.object,
    fieldSize: PropTypes.string,
    labelSize: PropTypes.number,
    minDate: PropTypes.string,
    maxDate: PropTypes.string,
    minDateToday: PropTypes.bool,
    showYear: PropTypes.bool,
  };

  componentDidMount() {
    const { input, minDate, maxDate } = this.props;
    this.setState({
      inputDate: input && input.value ? new moment(input.value).toDate() : undefined,
      minDate: minDate ? new moment(minDate).toDate() : undefined,
      maxDate: maxDate ? new moment(maxDate).toDate() : undefined,
    });
  }

  onChange = (date) => {
    const { input } = this.props;
    if (input) {
      this.setState({
        inputDate: date,
      });
      input.onChange(date.toISOString());
    }
  };

  render() {
    const { name, meta, label, labelSize, minDateToday, showYear } = this.props;
    const { inputDate, minDate, maxDate } = this.state;
    const size = labelSize ? labelSize : 2;
    return (
      <FormGroup
        controlId={name ? name : label}
        className={meta && meta.error && meta.submitFailed ? ' has-error' : ''}
      >
        <Col componentClass={ControlLabel} sm={labelSize}>
          {label} &nbsp;
        </Col>
        <Col sm={12 - size}>
          <div className={'datepicker-custom'}>
            <DatePickerSimple
              dobReadOnly={this.props.dobReadOnly}
              monthsShown={2}
              className="red-border"
              minDate={minDateToday ? moment().format() : minDate}
              maxDate={maxDate}
              showYear={showYear}
              selected={inputDate}
              onChange={::this.onChange}
            />
          </div>
          {meta && meta.touched && meta.error && (
            <div>
              <span className="input-error">{meta.error}</span>
            </div>
          )}
        </Col>
      </FormGroup>
    );
  }
}

export default DatePickerDob;
